import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CampaignDetailComponent } from './detail.component';

const routes: Routes = [{
	path: '',
	data: {
		title: 'Campaña',
		status: false,
		breadcrumb: "Campaña"
	},
	children: [
		{
			path: '',
			component: CampaignDetailComponent
		}
	]
}];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class DetailRoutingModule {}


// WEBPACK FOOTER //
// ./src/app/components/detail/detail-routing.module.ts